module.exports = __webpack_public_path__ + "static/img/rank_35.1dc05cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_35.png
// module id = ituv
// module chunks = 0